export default "__VITE_ASSET__f9d83ef4__"